import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SuccessDialog } from '../success-dialog/success-dialog';

@Component({
  selector: 'app-logout-dialog',
  standalone: false,
  templateUrl: './logout-dialog.html',
  styleUrl: './logout-dialog.less'
})
export class LogoutDialog {
 constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; subtitle: string },
    private matDialogRef: MatDialogRef<SuccessDialog>
  ) { }

  close(): void {
    this.matDialogRef.close('cancel');
  }
  logout(): void {
    this.matDialogRef.close('logout');
  }
}
